import pipe from 'lodash/fp/pipe'
import flatMap from 'lodash/fp/flatMap'
import uniqBy from 'lodash/fp/uniqBy'

const groupByLessonCategory = (lessons, orderedObj) =>
  lessons.reduce((acc, cv) => {
    if (acc[cv.category]) {
      acc[cv.category].push(cv)
    } else {
      acc[cv.category] = [cv]
    }
    return acc
  }, orderedObj)

const duplicateLessonsWithMultipleLocations = lessonTypes =>
  lessonTypes.flatMap(lessonType =>
    lessonType.locations.map(loc => ({
      ...lessonType,
      locationName: loc.name,
      locationId: loc.id,
    })),
  )

export const parseData = ({ coaches, __type }) => {
  const coach = coaches[0]

  const orderedObj = __type.enumValues.reduce((acc, cv) => {
    acc[cv.name] = []
    return acc
  }, {})

  const lessonTypeLocations = pipe(
    flatMap(lt => lt.locations),
    uniqBy('id'),
  )(coach.lessonTypes)

  const lessonTypes = duplicateLessonsWithMultipleLocations(coach.lessonTypes)
  return {
    coachName: coach.name,
    coachTitle: coach.coachProfile?.title,
    coachAvatar: coach.coachProfile?.profilePhoto,
    coachLocations: lessonTypeLocations,
    lessonTypes: groupByLessonCategory(lessonTypes, orderedObj),
  }
}
